// extracted by mini-css-extract-plugin
export default {"container":"L0Sd6b","title":"vnjzvQ","subtitle":"FEGDDM","textSecondary":"DxxQqL","progressBarWrapper":"dvUGCI","loadingDots":"rrIrqR","dot":"vnRVh6","dotPulse":"M9j9mR"};